import { render } from "./BusinessRegister.vue?vue&type=template&id=3250c184&scoped=true&ts=true"
import script from "./BusinessRegister.vue?vue&type=script&lang=ts"
export * from "./BusinessRegister.vue?vue&type=script&lang=ts"

import "./BusinessRegister.vue?vue&type=style&index=0&id=3250c184&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3250c184"]])

export default __exports__